"use strict";

export class EventListener {
    constructor(id) {
        this.id = id;
        this.callbacks = [];
    }

    registerCallback(callback) {
        return this.callbacks.push(callback) - 1;
    }

    deregisterCallback(callback) {
        this.callbacks.splice(this.callbacks.indexOf(callback), 1);
    }

    dispatch(args) {
        this.callbacks.forEach((e) => e(args));
    }
}